import React, { useEffect, useState } from "react";

const healthItems = [
  { img: "/assets/img/health-icon-01.png", title: "Cardiac Checkup" },
  { img: "/assets/img/health-icon-02.png", title: "Guthealth Checkup" },
  { img: "/assets/img/health-icon-01.png", title: "Wholebody Checkup" },
  { img: "/assets/img/health-icon-04.png", title: "Geriatric Checkup" },
];

const HealthCheckup = ({ search }) => {
  const [loading, setLoading] = useState(true);
  const [filtered, setFiltered] = useState(healthItems);

  useEffect(() => {
    setTimeout(() => setLoading(false), 800);
  }, []);

  useEffect(() => {
    const result = healthItems.filter((item) =>
      item.title.toLowerCase().includes(search.toLowerCase())
    );
    setFiltered(result);
  }, [search]);

  return (
    <section className="health-checkup-section-list">
      <div className="container">
        <div className="row">
          {loading
            ? // Skeleton Content
              [1, 2, 3, 4].map((_, i) => (
                <div className="col-lg-3 col-md-4 col-sm-6 mb-4" key={i}>
                  <div className="health-card skeleton">
                    <div className="skeleton-icon shimmer"></div>
                    <div className="skeleton-line long shimmer mt-3"></div>
                  </div>
                </div>
              ))
            : filtered.length === 0
            ? <p className="no-results">No checkups found.</p>
            : filtered.map((item, index) => {
                const words = item.title.split(" ");
                return (
                  <div className="col-lg-3 col-md-4 col-sm-6 mb-4" key={index}>
                    <div className="health-card">
                      <div className="health-img-wrapper mb-3">
                        <img src={item.img} alt={item.title} />
                      </div>
                      <h2 className="health-title">
                        {words.length >= 2 ? (
                          <>
                            {words[0]}
                            <br />
                            {words.slice(1).join(" ")}
                          </>
                        ) : (
                          item.title
                        )}
                      </h2>
                    </div>
                  </div>
                );
              })}
        </div>
      </div>
    </section>
  );
};

export default HealthCheckup;
